import { inputStyles } from "../styles/styles";

import React, { useEffect, useState } from "react";
import { Button, Grid, TextField } from "@material-ui/core";

import BaseWindow from "./public/BaseWindow";
import { numericMask } from "./public/TextMask";

import { connect } from "react-redux";
import { updateAlert } from "../store/alert/actions";
import {
  resetCustomerInfo,
  updateCustomerInfo,
} from "../store/customerInformation/actions";

import { useHistory, useParams } from "react-router-dom";
import {
  getByUUID,
  getCustomerWithNationalNo,
  sendApplicantCompany,
} from "../store/customerInformation/thunkActions";
import { bindActionCreators } from "redux";
import {
  appMessages,
  getNextStep,
  getNextStep4Easycep,
  linksStates,
} from "../utils/enums.ts";
import BaseTextField from "./public/BaseTextField";
import { getPrmData } from "../store/global/thunkActions";
import { getErrorMessage, PrmDataProperties } from "../utils/enums";
import { updateUnsuccessMsg, updateUnsuccessRedirectUrl } from "../store/unsuccess/actions";
import { addProcessContext } from "../store/processContext/actions";
import { getProductInfo } from "../store/limitAndPaymentInformation/thunkActions";

function Welcome(props) {
  const classes = inputStyles();
  let history = useHistory();
  let uuid = history.location.search.replace("?", "");
  const pageName = "welcome";

  const [tcknOrVkn, setTcknOrVkn] = useState("");
  const [tcknVknError, setTcknVknError] = useState(false);
  const [tcknVknErrorHelperText, setTcknVknErrorHelperText] = useState("");

  useEffect(() => {
    props.actions.resetCustomerInfo();
    props.actions
      .getPrmData({
        prmTableIn: Object.values(PrmDataProperties),
        externalId: uuid,
      })
      .then((prmRes) => {
        if (!prmRes.nextStatus && prmRes.result === "0") {
          props.actions.getByUUID({ uuid }).then((res) => {
            window.sessionStorage.setItem("sessionId", res.sessionId);
            if (res.appState === linksStates.LIMIT_NOT_ENOUGH) {
              props.actions
                .getProductInfo(
                  {
                    externalId: uuid,
                  },
                  true
                )
                .then((productInfoResponse) => {
                  props.actions.updateUnsuccessMsg(
                    "Tarafınıza " +
                      productInfoResponse?.productList[0]?.usableAmount +
                      " TL limitiniz onaylanmıştır. " +
                      "Tahsis edilen tutar, talep edilen ödeme tutarından daha az olduğu için işlem yapılamamaktadır. " +
                      res.companyCode +
                      " sistemi üzerinden talep edilen ödeme tutarını güncelleyerek tekrar deneyiniz."
                  );
                  // shopUrl[3] varsa firma paneline yönlendirme
                  try {
                    const shopUrlParts = productInfoResponse?.productList[0]?.shopUrl?.split(";");
                    if (shopUrlParts && shopUrlParts.length > 3 && shopUrlParts[3]) {
                      props.actions.updateUnsuccessRedirectUrl(shopUrlParts[3]);
                    }
                  } catch (err) {}
                });
            } else {
              if (res.nextStatus) {
                props.actions.updateUnsuccessMsg(
                  res.errorCode ? getErrorMessage(res.errorCode) : res.msg
                );
                //history.push(uuid + '/' + getNextStep(pageName, res.result));
                // shopUrl[3] varsa firma paneline yönlendirme
                try {
                  const shopUrlParts = res.shopUrl?.split(";");
                  if (shopUrlParts && shopUrlParts.length > 3 && shopUrlParts[3]) {
                    props.actions.updateUnsuccessRedirectUrl(shopUrlParts[3]);
                    console.log("Firma paneline yönlendirme URL'i set edildi: " + shopUrlParts[3]);
                  }
                } catch (err) {}
              }
            }
            if (res.isWaitingPage === "1") {
              history.push(uuid + "/platform-waiting");
            } else {
              const nextStepName =
                res.companyCode === "EASYCEPT"
                  ? getNextStep4Easycep(pageName, res.result)
                  : getNextStep(pageName, res.result);
              props.actions.addProcessContext({ stepName: nextStepName });

              let urlExpireDate = getExpiryDateWithFormat(
                res.expiryDate,
                res.expiryTime
              );

              props.actions.addProcessContext({ urlExpireDate });

              history.push(uuid + "/" + nextStepName);
            }
          });
        } else {
          if (prmRes.errorCode) {
            props.actions.updateUnsuccessMsg(getErrorMessage(prmRes.errorCode));
          } else {
            props.actions.updateUnsuccessMsg(prmRes.msg);
          }

          history.push(uuid + "/" + getNextStep(pageName, prmRes.result));
        }
      });
  }, []);

  const getExpiryDateWithFormat = (date, time) => {
    try {
      // str.substring(6, 8) + "." + str.substring(4, 6) + "." + str.substring(0, 4)
      const year = parseInt(date.substring(0, 4));
      const month = parseInt(date.substring(4, 6)) - 1;
      const day = parseInt(date.substring(6, 8));
      const hour = parseInt(time.substring(0, 2));
      const minutes = parseInt(time.substring(2, 4));
      const seconds = parseInt(time.substring(4, 6));
      return new Date(year, month, day, hour, minutes, seconds).getTime();
    } catch (err) {
      let urlExpireDate = new Date();
      urlExpireDate = urlExpireDate.setTime(
        urlExpireDate.getTime() + 15 * 60 * 1000
      );
      return urlExpireDate;
    }
  };

  const devamClick = (e) => {
    e.preventDefault();
    if (tcknOrVkn.length === 11) {
      props.actions.updateCustomerInfo({
        tckn: tcknOrVkn,
        isLimited: true,
      });
      history.push(uuid + "/" + getNextStep(pageName));
    } else if (tcknOrVkn.length === 10) {
      props.actions.updateCustomerInfo({
        vkn: tcknOrVkn,
        isLimited: false,
      });
      //history.push(getNextStep(pageName));
    } else {
      setTcknVknError(true);
      setTcknVknErrorHelperText(getErrorMessage("MS0003"));
    }
  };

  return <div></div>;
}

const mapStateToProps = (state) => {
  return {
    globalState: state.global,
    customerInformations: state.customerInformations,
    processContext: state.processContext,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: {
      getPrmData: bindActionCreators(getPrmData, dispatch),
      getByUUID: bindActionCreators(getByUUID, dispatch),
      resetCustomerInfo: bindActionCreators(resetCustomerInfo, dispatch),
      updateCustomerInfo: bindActionCreators(updateCustomerInfo, dispatch),
      sendApplicantCompany: bindActionCreators(sendApplicantCompany, dispatch),
      updateAlert: bindActionCreators(updateAlert, dispatch),
      updateUnsuccessMsg: bindActionCreators(updateUnsuccessMsg, dispatch),
      updateUnsuccessRedirectUrl: bindActionCreators(updateUnsuccessRedirectUrl, dispatch),
      addProcessContext: bindActionCreators(addProcessContext, dispatch),
      getProductInfo: bindActionCreators(getProductInfo, dispatch),
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Welcome);
